import { React, PropTypes } from '@gasbuddy/react';
import { Menu, Icon } from 'semantic-ui-react';

export class Pagination extends React.PureComponent {
  static defaultProps = {
    total: 0,
    offset: 0,
  }

  static propTypes = {
    total: PropTypes.number,
    pageSize: PropTypes.number.isRequired,
    offset: PropTypes.number,
    onPageSelected: PropTypes.func.isRequired,
  };

  render() {
    const { total, pageSize, offset, onPageSelected, ...menuProps } = this.props;

    if (!Number.isFinite(total) || total <= 0) {
      return null;
    }

    const menuItems = [];
    const totalPages = Math.ceil(total / pageSize, 10);
    const curPage = Math.floor(offset / pageSize, 10);

    const start = Math.max(0, curPage - 3);
    const end = Math.min(totalPages, start + 7);

    if (curPage > 0) {
      menuItems.push(
        <Menu.Item as="a" icon onClick={() => onPageSelected(Math.max(0, (start - 6) * pageSize))}>
          <Icon name="left chevron" />
        </Menu.Item>,
      );
    }

    for (let pn = start; pn < end; pn += 1) {
      menuItems.push(
        <Menu.Item
          name={String(pn + 1)}
          key={`page-${pn}`}
          active={curPage === pn}
          onClick={() => onPageSelected(pn)}
        />,
      );
    }

    if (curPage < totalPages - 1) {
      menuItems.push(
        <Menu.Item as="a" icon onClick={() => onPageSelected((start + 9) * pageSize)}>
          <Icon name="right chevron" />
        </Menu.Item>,
      );
    }
    return (
      <Menu pagination {...menuProps}>
        {menuItems}
      </Menu>
    );
  }
}
